import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import type { ReferenceListProps } from './ReferenceList.types'

// A reference is context for a reader, not evidence of a mention, so it stays collapsed.
export function ReferenceList({ references }: ReferenceListProps) {
  if (!references?.length) return null

  return (
    <Accordion type="single" collapsible className="mt-1">
      <AccordionItem value="references">
        <AccordionTrigger className="py-1 text-xs font-normal text-muted-foreground hover:no-underline">
          Also retrieved, not cited ({references.length})
        </AccordionTrigger>
        <AccordionContent className="pb-1">
          <ul className="space-y-1">
            {references.map((r) => (
              <li key={r.url} className="text-xs">
                <a
                  href={r.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={r.title?.trim() || undefined}
                  className="text-muted-foreground/70 hover:text-foreground underline break-all"
                >
                  {r.domain || r.url}
                </a>
              </li>
            ))}
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
